// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-mask{z-index:11;top:0;position:fixed;height:100vh;width:100%;background-color:var(--overlay-color);transition:background-color 150ms ease-in-out}.background-mask-transition-enter .background-mask,.background-mask-transition-leave-to .background-mask{background-color:var(--overlay-color)}\n", ""]);
// Exports
exports.locals = {
	"extraSmallBreakpoint": "320px",
	"smallBreakpoint": "425px",
	"mobileBreakpoint": "768px",
	"tabletBreakpoint": "970px",
	"desktopBreakpoint": "1200px",
	"largeBreakpoint": "1400px",
	"extraLargeBreakpoint": "1600px"
};
module.exports = exports;
